<form
  (ngSubmit)="onSubmit()"
  [formGroup]="formGroup">
  <love-it-modal-header
    (close)="modal.dismiss()"
    title="Benutzer bearbeiten"></love-it-modal-header>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between">
          <label for="reset-password-new">Passwort</label>
        </div>
        <div
          [ngClass]="{
            'is-invalid error': submitted && formGroup.get('newPassword')?.errors,
          }"
          class="input-group input-group-merge form-password-toggle">
          <input
            [ngClass]="{
              'is-invalid error': submitted && formGroup.get('newPassword')?.errors,
            }"
            [type]="passwordTextType ? 'text' : 'password'"
            aria-describedby="reset-password-new"
            autofocus
            class="form-control form-control-merge"
            formControlName="newPassword"
            id="reset-password-new"
            placeholder="············"
            tabindex="1" />
          <span class="input-group-text cursor-pointer"
            ><i
              (click)="togglePasswordTextType()"
              [ngClass]="{
                'icon-eye-off': passwordTextType,
                'icon-eye': !passwordTextType,
              }"
              class="feather font-small-4"></i
          ></span>
        </div>
        @if (submitted && formGroup.get("newPassword")?.errors) {
          <div class="invalid-feedback">
            @if (formGroup.get("newPassword")?.errors["required"]) {
              <div>Passwort ist ein Pflichtfeld.</div>
            }
            @if (formGroup.get("newPassword")?.errors["minlength"]) {
              <div>Das Passwort muss mindestens 5 Zeichen haben</div>
            }
          </div>
        }
      </div>
      <div class="col-sm-12">
        <div class="d-flex justify-content-between">
          <label for="reset-password-confirm">Passwort wiederholen</label>
        </div>
        <div
          [ngClass]="{
            'is-invalid error': submitted && formGroup.get('confirmPassword')?.errors,
          }"
          class="input-group input-group-merge form-password-toggle">
          <input
            [ngClass]="{
              'is-invalid error': submitted && formGroup.get('confirmPassword')?.errors,
            }"
            [type]="confPasswordTextType ? 'text' : 'password'"
            aria-describedby="reset-password-confirm"
            class="form-control form-control-merge"
            formControlName="confirmPassword"
            id="reset-password-confirm"
            placeholder="············"
            tabindex="2" />
          <span class="input-group-text cursor-pointer"
            ><i
              (click)="toggleConfPasswordTextType()"
              [ngClass]="{
                'icon-eye-off': confPasswordTextType,
                'icon-eye': !confPasswordTextType,
              }"
              class="feather font-small-4"></i
          ></span>
        </div>
        @if (submitted && formGroup.get("confirmPassword")?.errors) {
          <div class="invalid-feedback">
            @if (formGroup.get("confirmPassword")?.errors["pwCheck"]) {
              <div>Die Passwörter stimmen nicht überein</div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      (click)="onSubmit()"
      class="btn-mobile-group btn-primary"
      rippleEffect
      type="button">
      Speichern
    </button>
    <button
      (click)="modal.dismiss()"
      class="btn-mobile-group btn-outline-secondary"
      rippleEffect
      type="button">
      Abbrechen
    </button>
  </div>
</form>
